import React, { useMemo, useState } from 'react';
import { Button, Card } from 'react-bootstrap';

import { usePokCore } from '../../../common/hooks/usePokCore';
import { useNotifications } from '../../../common/hooks/useNotifications';
import { Waiting } from '../../../common/components/Waiting/Waiting';
import { useTranslation } from '../../../common/hooks/useTranslation';
import {
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { OneToolTeamSearch } from '../../components/OneToolTeams/OneToolTeamSearch';

export const OneToolTeamsView: React.FC = () => {
  const pok = usePokCore();
  const notifications = useNotifications();
  const [waiting, setWaiting] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const { t, tk } = useTranslation('administrationLng');

  const handleSync = () => {
    setWaiting(true);
    pok.oneToolTeams
      .sync()
      .then(() => {
        setWaiting(false);
        notifications.saveCompleted();
        setRefresh(r => !r);
      })
      .catch(e => {
        setWaiting(false);
        notifications.caughtError(e);
      });
  };

  const getData = useMemo(
    () =>
      ((
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
      ) =>
        pok.oneToolTeams.getAllByPortion(
          t,
          tk,
          pageSize,
          pageNumber,
          orderBy,
          orderDirection,
          filterText,
          filterColumns,
        )) as GridGetterFunction,
    [pok.oneToolTeams, t, tk],
  );

  const getCount = useMemo(
    () =>
      ((filterText: string, filterColumns?: string) =>
        pok.oneToolTeams.getAllCount(
          filterText,
          filterColumns,
        )) as GridCountFunction,
    [pok.oneToolTeams],
  );

  return (
    <Card className="main-card">
      <Card.Body className="m-3">
        <Card.Title className="pb-3">
          {t(tk.administration.oneToolTeams)}
        </Card.Title>
        <Button variant="outline-primary" onClick={handleSync} className="mb-3">
          {t(tk.administration.synchrWithOneTool)}
        </Button>
        {waiting && <Waiting />}
        {!waiting && (
          <OneToolTeamSearch
            getData={getData}
            getCount={getCount}
            refresh={refresh}
          />
        )}
      </Card.Body>
    </Card>
  );
};
